// extracted by mini-css-extract-plugin
export default {"mobileMaxWidth":"575px","tabletMaxWidth":"768px","tabletMinWidth":"576px","largeMaxWidth":"1024px","largeMinWidth":"769px","XLMaxWidth":"1440px","XLMinWidth":"1025px"};